import React from 'react';

import { ReactComponent as JavelinLogo } from 'assets/icons/logo-javelin.svg';
const YEAR = new Date().getFullYear();

const TradeMark = () => {
  return (
    <div className="flex justify-between w-28 text-javelin-blueGray text-sm pb-4 pr-2 select-none bg-white">
      <p>©</p>
      <JavelinLogo className="h-auto w-12" />
      <p>{YEAR}</p>
    </div>
  );
};

export default TradeMark;
